function addToCart(productId, quantity = 1, attributes = {}) {
	return new Promise((resolve, reject) => {
		let data = {
			_token: window.laravel._token,
			id: productId,
			quantity: quantity
		};

		data = Object.assign({}, data, attributes);

		$.post(window.laravel.routes.addToCart, data)
			.then(data => {
				window.gtm.addToCart(productId, data.name, data.singlePrice, quantity, window.laravel.currency);
				window.flashMessage("cart-done", "success");
				updateHeaderCart(data);
				resolve(data);
			})
			.catch(data => {
				window.flashMessage("cart-fail", "error");
				reject(data);
			});

	});
}

function handleItemPrice(productData, wrapper){
    wrapper.find(".total-price-without-vat").text(productData.productPriceWithoutVat);
    wrapper.find(".total-vat").text(productData.productVat);
    wrapper.find(".total-price").text(productData.productPrice);
}

function refreshCartPrices(data){
    $("#cart-footer-vat .price").text(data.totalVat);
    $("#cart-footer-price-without-vat .price").text(data.priceWithoutVat);
    $("#cart-footer-total-price .price").text(data.totalPrice);
    $(".coupon-discount-amount").text("-" + data.discountAmount);

    // Display "Cart Empty" message
    if (!data.cartItems) {
        $(".banner-cart.banner-text-in").removeClass("hide");
        $(".non-empty-cart-content").addClass("hide");
    }
}

// Cart icon and details in header
let headerCartEls = {
	"count": $("#header-cart-items-count"),
	"price-wrapper": $("#header-cart-total-price"),
	"price": $("#header-cart-total-price > span")
};

function updateHeaderCart(data) {
	// Toggle elements' visibility
	headerCartEls["price-wrapper"].toggleClass("hide", !data.totalPriceRaw);
	headerCartEls["count"].toggleClass("hide", !data.cartItems);

	// Fill elements
	headerCartEls["count"].text(data.cartItems);
	headerCartEls["price"].text(data.totalPrice);
}

function updateCartProductQuantity(key, difference, el) {
    let currentValue = parseInt(el.find("input").val());
    let newValue = currentValue + difference;
    if (newValue > 0) {
        el.find("input").val(newValue);
        el.find(".item-amount").text(newValue);

        $.post(window.laravel.routes.cartUpdateQuantity, { _token: window.laravel._token, key: key, quantity: newValue}, function(data){
        	if (difference === -1)
        		window.gtm.removeFromCart(data.gtm.id, data.gtm.name, data.gtm.price, 1, window.laravel.currency);
        	else
        		window.gtm.addToCart(data.gtm.id, data.gtm.name, data.gtm.price, 1, window.laravel.currency);

            handleItemPrice(data, el.parent());
            refreshCartPrices(data);
            updateHeaderCart(data);
        });
    }
}

$(document).ready(function(){
    // handle item prices
    $(".plus-one").on("click", function () {
        updateCartProductQuantity($(this).data("key"), 1, $(this).parent());
    });
    $(".minus-one").on("click", function () {
        updateCartProductQuantity($(this).data("key"), -1, $(this).parent());
    });

    //remove item
    $('.cart-content .remove-item a').on("click", function () {
        let confirm = window.confirm("Opravdu chcete odstranit položku?");
		if (confirm) {
			$.post(window.laravel.routes.cartRemoveItem, {
					_token: window.laravel._token,
					key: $(this).data("key")
				}, data => {
					window.gtm.removeFromCart(data.gtm.id, data.gtm.name, data.gtm.price, data.gtm.quantity, window.laravel.currency);
					$(this).closest(".cart-item ").remove();
            		refreshCartPrices(data);
            		updateHeaderCart(data);
				}
			);
		}
    });

    // add voucher to cart
    $(".voucher-cart-form button.cart-icon").on("click", function() {
        let btn = $(this);
        let form = btn.closest(".voucher-cart-form");
        let selectedRadio = form.find("input[type='radio']:checked");

        addToCart(form.data("product-id"), 1, {
            [selectedRadio.data("attribute")]: selectedRadio.val()
        }).then(() => {
        	form.find("span.close").click();

        	if (!!btn.data("redirect-to-cart"))
                document.location.href = window.laravel.routes.cart;
		});

        return false;

    });

});
